import { PageHeader } from '@zeiss/lib-components';
import { useTranslation } from 'react-i18next';

export const Organizations = () => {
  const { t } = useTranslation(['common']);

  return <PageHeader headline={t('common:nav.organizations')} />;
};
